import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

import { Table as _Table } from '../style';

export const Table = styled(_Table)(() =>
  mq({
    width: '100px',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    backgroundColor: defaultTheme.background.white,
    zIndex: 2,
  }),
);

export const NameWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    padding: defaultTheme.spacing.s,
    '& > span': {
      fontSize: defaultTheme.font.size.s,
      fontWeight: 'bold',
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);
